import { store } from 'redux/store';

import { getDocumentBlob } from 'modules/_shared/components/CKEditor/utils/getDocumentBlob';
import { downloadBlob } from 'utils/downloadBlob';
import {
  getDocumentReplacedWithTags,
  ReplaceDocumentTagsSources,
} from 'modules/documents/api/getDocumentReplacedWithTags';

type GenerateDocumentProps = {
  documentId: string;
  documentName: string;
  sources: ReplaceDocumentTagsSources;
  language: string;
  footerHtml: string;
};

export const generateDocumentWithTags = async ({
  documentId,
  documentName,
  sources,
  language,
  footerHtml,
}: GenerateDocumentProps) => {
  const result = await store.dispatch(
    getDocumentReplacedWithTags({
      documentId,
      sources,
      language,
    })
  );

  const blob = await getDocumentBlob({
    html: result?.html || '',
    footerHtml: footerHtml || '',
  });

  downloadBlob(blob, documentName || '');
};
